/**
 * Port of cdc-web `src/utils/number/currencyFormatter.ts` 的
 * `displayVolumeOrPlaceholder`（1:1）。
 *
 * 刻意不复用 cdc-market `src/utils/number/format.ts` 的 `formatVolume`
 * （K/M/B 缩写）——卡片规格要求 "$1,234,567 vol." 全数字形式，与 cdc-web
 * prediction 卡片保持一致。
 */
export function displayVolumeOrPlaceholder(volume: string | number | undefined): string {
  if (volume === undefined || volume === '' || volume === null) return '-'
  const num = Number(volume)
  if (Number.isNaN(num)) return '-'
  return `${Math.trunc(num).toLocaleString('en-US')}`
}
